module.exports = __webpack_public_path__ + "img/link.22c28f2c.png";